import { get, flatMap, uniqBy } from 'lodash'
import { useDomains } from '../../contexts/DomainsContext'
import { useIngresses } from '../../contexts/IngressesContext'
import { useServices } from '../../contexts/ServicesContext'
import DomainChip from './DomainChip'

function ProjectDomainsChips({ projectId }) {
  const { domainsById } = useDomains()
  const { ingressesByServiceId } = useIngresses()
  const { servicesByProjectId } = useServices()

  if (!projectId) return null

  const services = get(servicesByProjectId, projectId, [])

  const domainChips = flatMap(services, (service) => {
    const ingresses = get(ingressesByServiceId, service.id, [])

    return flatMap(ingresses, (ingress) => {
      const domainIds = get(ingress, 'domainIds', [])
      const path = get(ingress, 'path', '')

      return domainIds.map((domainId) => {
        const domain = get(domainsById, domainId)
        if (!domain) return null

        return {
          key: `${ingress.id}-${domain.id}`,
          domain,
          path,
        }
      }).filter(Boolean)
    })
  })

  const uniqueChips = uniqBy(domainChips, (chip) => `${chip.domain.id}-${chip.path}`)

  return uniqueChips.map((chip) => (
    <DomainChip
      key={chip.key}
      domain={chip.domain}
      path={chip.path}
    />
  ))
}

export default ProjectDomainsChips
